<div class="as-label-main-container as-pointer">
  <div
    (click)="options.showMore ? showMore() : null"
    class="as-label-container-blue"
  >
    <p class="as-label-text as-text-blue">
      {{ label }}
      @if(options.showMore){ -<span class="as-font-underline"> Ver más</span>
      }
    </p>
  </div>
</div>
